export class Password {

    constructor() { }

    public TempPwdID: string;
    public JurisID: number;
    public UserID: string;
    public UserRole: string;
    public Email: string;
    public Pwd: string;
    public ConfirmNewPassword: string;
    public TempPwd: string;
    public IsActive: number;
    public IsValidTo?: Date;
    public IPaddress: string;
    public Url: string;
    public IsAdmin: number;
    public CreatedPFID: string;
    public CreatedDttmUTC?: Date;
    public ModifiedPFID: string;
    public ModifiedDttmUTC?: Date;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/password.model.ts